import m from "mithril";
import BaseComponent from "../../BaseComponent";
import InterviewGoalsEditor, {InterviewGoalsEditorOptions} from "./InterviewGoalsEditor";

export default class InterviewForm extends BaseComponent {

    private editorHost: HTMLElement|null = null;

    public init(): void {
        const editorHost = this.$component.find("[data-interview-goals-editor]").get(0);
        if (!editorHost || !this.options) {
            console.warn("InterviewForm: missing goals editor host or options");
            return;
        }
        this.editorHost = editorHost;

        m.mount(editorHost, new InterviewGoalsEditor(
            this.options as InterviewGoalsEditorOptions,
            this.translator.translations,
        ));
    }

    public beforeRemove(): void {
        if (this.editorHost) {
            m.mount(this.editorHost, null);
            this.editorHost = null;
        }
    }
}
